import { useContext } from 'react';

import { EditModeContext, IEditModeContext } from './EditModeContextProvider';

const useEditModeContext = (): IEditModeContext => {
  return useContext(EditModeContext);
};

export default useEditModeContext;
